import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { apiLink } from "../../../constant/api-link";
import { CompanySelectorListModel, CompanySelectorQueryModel } from "../../../model/builk/company/company-selector.model";
import { EmployeeListModel, EmployeeListQueryModel } from "../../../model/builk/company/employee.model";

@Injectable({
    providedIn: "root"
})
export class CompanyService {

    constructor(
        private http: HttpClient
    ) { }

    sub: any;

    getCompanySelecter(model: CompanySelectorQueryModel): Observable<CompanySelectorListModel> {
        const url = apiLink.getCompanySelecter;
        let params = new HttpParams();
        params = params.append('page', model.page.toString());
        params = params.append('limit', model.limit.toString());
        if (model.search != undefined && model.search != null && model.search != '') {
          params = params.append('search', model.search);
        }
        return this.http.get<CompanySelectorListModel>(url, { params: params });
    }

    getEmployeeSearchList(model: EmployeeListQueryModel): Observable<EmployeeListModel> {
      const url = apiLink.getEmployeeSearchList;
      let params = new HttpParams();
      params = params.append('companySurrKey', model.companySurrKey.toString());
      params = params.append('page', model.page.toString());
      params = params.append('limit', model.limit.toString());
      if (model.query != undefined && model.query != null && model.query != '') {
        params = params.append('query', model.query);
      }
      return this.http.get<EmployeeListModel>(url, { params: params });
  }
}
